function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_522",
  "data-name": "Group 522",
  transform: "translate(0.432 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_377",
  "data-name": "Path 377",
  d: "M890.559,312.155a6.769,6.769,0,0,1,6.669-6.865H957.62a6.768,6.768,0,0,1,6.669,6.865v46.939a6.768,6.768,0,0,1-6.669,6.865H897.228a6.769,6.769,0,0,1-6.669-6.865V321.346",
  transform: "translate(-876.221 -299.959)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_378",
  "data-name": "Path 378",
  d: "M890.559,337.8l13.524-13.115a4.652,4.652,0,0,1,6.695.159l8.784,9.3a4.655,4.655,0,0,0,6.873-.028l19.16-20.595a4.655,4.655,0,0,1,6.874-.028L964.29,326.02",
  transform: "translate(-876.221 -288.887)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_48",
  "data-name": "Ellipse 48",
  cx: 5.289,
  cy: 5.354,
  rx: 5.289,
  ry: 5.354,
  transform: "translate(41.701 18.2)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_411",
  "data-name": "Group 411",
  transform: "translate(0.068 0)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_137",
  "data-name": "Line 137",
  x2: 10,
  transform: "translate(0 5)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_138",
  "data-name": "Line 138",
  x2: 10,
  transform: "translate(4.999 0) rotate(90)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeWidth: 1
})));

var SvgJoratoNewImage = function SvgJoratoNewImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.207,
    height: 67,
    viewBox: "0 0 89.207 67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoNewImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-new-image.b6d16403.svg";
export { ForwardRef as ReactComponent };